<template>
  <section
    class="component-c57cd1bd"
    resmed-component-name="card_carousel_50/50_icon-line_figure_graphic_text_2cta"
    v-bind:style="{
      'background-color': acf.layout['background-color'],
      'background-image': `url(${acf.layout['background-image']})`,
    }"
  >
    <div
      class="component"
      v-bind:class="[`text-color-${acf.layout['text-color']}`]"
    >
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="headings text-center mb-4">
              <eyebrow-icon
                v-if="acf.eyebrowicon"
                v-bind:eyebrowicon="acf.eyebrowicon"
                v-bind:align="'center'"
              ></eyebrow-icon>
              <h5 v-if="acf.title">{{ acf.title }}</h5>

              <h2 v-html="acf.headline"></h2>
              <div v-html="acf.description"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="swiper container px-xs-sm-2">
        <div class="row">
          <div class="col" style="padding: 0">
            <div class="seek">
              <div class="seek-wrapper" v-show="sliderControlsVisible">
                <a
                  ref="swiperButtonPrev"
                  href="#"
                  class="btn navigation-icon left-caret swiper-button-prev"
                ></a>
                <a
                  ref="swiperButtonNext"
                  href="#"
                  class="btn navigation-icon right-caret swiper-button-next"
                ></a>
              </div>

              <div
                ref="swiperContainer"
                class="swiper-container"
                v-bind:class="`-mode-${[$root.mode]}`"
              >
                <div class="items swiper-wrapper">
                  <div
                    class="item swiper-slide mb-3 mb-md-0"
                    v-for="(item, index) in acf.cards"
                    v-bind:class="{
                      overflow: overflow && index >= 2,
                      'text-center': acf.layout['text-align'] === 'center',
                    }"
                  >
                    <div class="wrapper">
                      <figure>
                        <img
                          v-if="item.image"
                          class="img-fluid"
                          v-bind:src="item.image.sizes.large"
                          alt=""
                        />

                        <figcaption>
                          <h5 v-if="item.name">{{ item.name }}</h5>
                          <h3 v-html="item.title"></h3>
                          <div v-html="item.description"></div>

                          <div
                            v-if="item.cta"
                            class="call-to-action mt-4"
                            v-bind:class="{
                              'justify-content-center':
                                acf.layout['text-align'] === 'center',
                            }"
                          >
                            <a
                              v-bind:href="item.cta[0].cta.href"
                              :target="item.cta[0].cta.target || '_self'"
                              class="ctaButton cta-pill filled-red icon right-arrow"
                              >{{ item.cta[0].cta.text }}</a
                            >
                            <a
                              v-if="item.cta[1]"
                              v-bind:href="item.cta[1].cta.href"
                              :target="item.cta[1].cta.target || '_self'"
                              class="ctaButton cta-pill hallow-red mt-3"
                              >{{ item.cta[1].cta.text }}</a
                            >
                          </div>
                        </figcaption>
                      </figure>
                    </div>
                  </div>

                  <a
                    href="#"
                    v-on:click.prevent="overflow = !overflow"
                    v-if="overflow"
                    class="
                      d-inline-block d-md-none
                      btn
                      cta-pill
                      hallow-red
                      icon
                      move-expand
                    "
                    style="margin: 3rem auto 0 auto"
                    >Load more</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-show="sliderControlsVisible">
          <div class="col">
            <div ref="swiperPagination" class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import helper from "../../mixins/swiper-helper";

export default {
  name: "component-c57cd1bd", // card_carousel_50/50_icon-line_figure_graphic_text_2cta
  props: ["acf"],
  data() {
    return {
      initialized: false,
      slider: undefined,
      overflow: this.acf.cards.length > 2,
    };
  },
  mixins: [helper],
  computed: {
    sliderControlsVisible() {
      return this.shouldUseSlider && this.acf.cards.length > 2;
    },
    shouldUseSlider() {
      return !["xs", "sm"].includes(this.$root.mode);
    },
  },
  watch: {
    shouldUseSlider(v) {
      if (this.initialized) {
        if (v) {
          this.swhReload();
        } else {
          this.overflow = this.acf.cards.length > 2;
          this.swhDestroy();
        }
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.shouldUseSlider) {
        this.swhReload();
      }

      this.initialized = true;
    });
  },
  methods: {
    swhCreate() {
      this.slider = new swiper(this.$refs.swiperContainer, {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 0,
        freeMode: false,
        freeModeSticky: true,
        pagination: {
          el: this.$refs.swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: this.$refs.swiperButtonNext,
          prevEl: this.$refs.swiperButtonPrev,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-c57cd1bd {
  background-size: contain;
  background-position: center top;
  background-repeat: no-repeat;
  padding: 6rem 0 4rem 0;
}

.component {
  &.text-color-white {
    h2,
    h3,
    h5 {
      color: $cc-resmed-white;
    }

    h2,
    h5 {
      &:before {
        background-color: $cc-resmed-white;
      }
    }
  }

  h2 {
    margin-bottom: 1.5rem;
  }

  h3 {
    margin-bottom: 0.75rem;
  }

  h5 + h2 {
    &:before {
      display: none;
    }
  }

  .headings {
    h2,
    h5 {
      position: relative;
      margin-bottom: 0.75rem;

      @extend %eyebrow-center;
    }
  }

  @media (max-width: 767px) {
    .overflow {
      display: none;
    }
  }

  .swiper {
    @media (max-width: 991px) {
      // max-width: 90vw;
    }
  }

  .seek-wrapper {
    position: absolute;
    z-index: 1;

    width: 30%;
    bottom: -42px;
    left: 50%;
    transform: translateX(-50%);

    @media (min-width: 992px) {
      width: 20%;
    }

    @media (min-width: 1306px) {
      width: 100%;
      bottom: auto;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    a:nth-child(1) {
      float: left;
      transform: translateX(-4rem) scale(1.4);
    }

    a:nth-child(2) {
      float: right;
      transform: translateX(4rem) scale(1.4);
    }
  }

  .-mode-md,
  .-mode-lg,
  .-mode-xl {
    &.swiper-container {
      position: relative;
      width: 100%;
      height: 100%;

      overflow: hidden;
      padding: 1rem 0 2rem 0;
      margin: 0 auto;
      z-index: 1;
    }

    .items {
      display: flex;
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 1;
    }

    .item {
      display: flex;
      flex-shrink: 0;
      align-items: stretch;

      padding: 0 0.725rem;
      width: calc(100% / 2);
    }
  }

  .item {
    padding: 0 0.625rem;

    *:not(a) {
      color: $cc-resmed-black;
    }

    > div {
      box-shadow: -3px 0.875rem 12px 0 rgba(0, 0, 0, 0.125);
      border-radius: 6px;
      overflow: hidden;
    }

    .embed-responsive-item {
      border-radius: 6px;
      overflow: hidden;
    }

    .wrapper {
      display: flex;
    }

    figure {
      display: flex;
      flex-direction: column;
      background-color: $cc-resmed-white;
      width: 100%;

      img {
        padding: 3rem 0 1rem 0;
        max-width: 230px;
        align-self: center;
      }

      figcaption {
        padding: 2rem;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        width: 100%;

        h3 + div {
          flex-grow: 1;
        }

        @media (min-width: 992px) {
          padding: 2.5rem 3.5rem;
        }
      }
    }

    .call-to-action {
      overflow: hidden;

      .btn {
        display: table;
      }

      @media (min-width: 768px) {
        .btn {
          margin: 0 auto;
          display: inline-block;
        }
      }

      &.justify-content-center {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-items: center;

        .btn {
          margin: 0 auto;
          display: inline-block;
        }
      }
    }
  }
}
</style>